"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This component implements https://confluence.oci.oraclecorp.com/display/UX/Health+Status
 */
var React = require("react");
var Icon_1 = require("../../resources/Icon");
var Aria_1 = require("../../resources/Aria");
var classNames = require("classnames");
var status_1 = require("./status");
var svgs_1 = require("../../utils/svgs");
// Health has unique icons so we need to additionally map those.
var icons = (_a = {},
    _a[status_1.StatusType.Success] = Icon_1.default.Check,
    _a[status_1.StatusType.Warning] = Icon_1.default.Warning,
    _a[status_1.StatusType.Danger] = Icon_1.default.CloseCircle,
    _a[status_1.StatusType.Muted] = Icon_1.default.MinusCircle,
    _a[status_1.StatusType.Info] = Icon_1.default.Info,
    _a);
/**
 * OUI health label component.
 *
 * @oui-component HealthLabel
 */
var HealthLabel = function (_a) {
    var statusType = _a.statusType, children = _a.children, testId = _a.testId, rest = __rest(_a, ["statusType", "children", "testId"]);
    // Because the text and icon colors don't match(some times) we need to map them.
    var colors = status_1.getStyles(statusType);
    var hgdsSVG = svgs_1.default(status_1.StatusType[statusType].toString());
    return (React.createElement("span", __assign({ className: classNames("oui-health-label", hgdsSVG && "oui-health-label__container", !hgdsSVG && colors.text) }, rest, { role: Aria_1.Roles.Status, "data-test-id": testId }),
        !hgdsSVG && (React.createElement("span", { 
            // Change the component key when the status change forces the component to unmount/mount
            // thus have UIkit re-run its icon code.
            key: statusType.toString(), "data-oui-icon": "icon: " + icons[statusType] + "; ratio: 0.7", className: classNames("oui-margin-small-right", "oui-center-status-icon", colors.icon), "aria-hidden": "true" })),
        hgdsSVG,
        children));
};
/**
 * A health label component.
 */
exports.default = HealthLabel;
//# sourceMappingURL=HealthLabel.js.map